import request from '@/utils/request'


// 查询设备摄像头设置列表
export function listCameraSetting(query) {
  return request({
    url: '/mibo/device-camera-setting/list',
    method: 'get',
    params: query
  })
}

// 查询设备摄像头设置分页
export function pageCameraSetting(query) {
  return request({
    url: '/mibo/device-camera-setting/page',
    method: 'get',
    params: query
  })
}

// 查询设备摄像头设置详细
export function getCameraSetting(data) {
  return request({
    url: '/mibo/device-camera-setting/detail',
    method: 'get',
    params: data
  })
}

// 新增设备摄像头设置
export function addCameraSetting(data) {
  return request({
    url: '/mibo/device-camera-setting/add',
    method: 'post',
    data: data
  })
}

// 修改设备摄像头设置
export function updateCameraSetting(data) {
  return request({
    url: '/mibo/device-camera-setting/edit',
    method: 'post',
    data: data
  })
}

// 删除设备摄像头设置
export function delCameraSetting(data) {
  return request({
    url: '/mibo/device-camera-setting/delete',
    method: 'post',
    data: data
  })
}
